import { ForemanCache } from "./ForemanCache"
import { Employee } from "../Employee/Employee"
import { ReworkTask, WorkItemTask } from "../Work/WorkItemTask"
import { Constraint } from "../Work/Constraint"
import { WorkItem } from "../Work/WorkItem"
import { RequestBacklog } from "../Work/Request"
import { DirectReportAttendance } from "../Employee/Attendance"
import { Pallet, PalletItem } from "../Material/Order"
import { TimeSheet } from "../Reports/ShiftEnd/TimeSheet"
import { Activity } from "../Reports/ShiftEnd/Activity"
import { OfflineProgressRecord } from "../Reports/ShiftEnd/ShiftEndWorkItems"
import { WorkItemAttachmentCache } from "./ForemanCache"
import { UpdatedAttachment } from "../Upload/Attachment"

// Change tracking enum
export enum ChangeType {
    INSERTED = 'inserted',
    UPDATED = 'updated',
    DELETED = 'deleted',
    UNCHANGED = 'unchanged'
}

// Base change tracking interface
export interface ChangeTracker<T> {
    entity: T
    changeType: ChangeType
    originalId?: number // For tracking renamed/merged entities
    timestamp: Date
    uid: string
    logId: string
}

// Extended types with change tracking
export type EmployeeChange = ChangeTracker<Employee>
export type WorkItemChange = ChangeTracker<WorkItem>
export type WorkItemTaskChange = ChangeTracker<WorkItemTask>
export type ReworkTaskChange = ChangeTracker<ReworkTask>
export type ConstraintChange = ChangeTracker<Constraint>
export type RequestBacklogChange = ChangeTracker<RequestBacklog>
export type DirectReportAttendanceChange = ChangeTracker<DirectReportAttendance>
export type PalletChange = ChangeTracker<Pallet>
export type PalletItemChange = ChangeTracker<PalletItem>
export type TimeSheetChange = ChangeTracker<TimeSheet>
export type ActivityChange = ChangeTracker<Activity>
export type ProgressRecordChange = ChangeTracker<OfflineProgressRecord>
export type WorkItemAttachmentChange = ChangeTracker<WorkItemAttachmentCache>
export type UpdatedAttachmentChange = ChangeTracker<UpdatedAttachment>

// Main MutationSnapshot type
export type MutationSnapshot = {
    userId: number
    // createdAt: Date
    // Entity changes with tracking
    employee?: EmployeeChange
    directReports: EmployeeChange[]
    workItems: WorkItemChange[]
    tasks: WorkItemTaskChange[]
    reworks: ReworkTaskChange[]
    constraints: ConstraintChange[]
    requests: RequestBacklogChange[]
    workItemAssignments: WorkItemAssignmentChange[]
    taskAssignments: TaskAssignmentChange[]
    reworkAssignments: ReworkAssignmentChange[]
    qcWorkers: EmployeeChange[]
    attendance: DirectReportAttendanceChange[]
    pallets: PalletChange[]
    palletItems: PalletItemChange[]
    timesheets: TimeSheetChange[]
    timeRecords: ActivityChange[]
    progressRecords: ProgressRecordChange[]
    attachments: WorkItemAttachmentChange[]
    consentForms: ConsentFormChange[]
    updatedAttachments: UpdatedAttachmentChange[]
}

// Assignment change types
export type WorkItemAssignmentChange = ChangeTracker<{
    workerId: number
    workItemId: number
}>

export type TaskAssignmentChange = ChangeTracker<{
    workerId: number
    workItemTaskId: number
}>

export type ReworkAssignmentChange = ChangeTracker<{
    workerId: number
    reworkId: number
}>

export type ConsentFormChange = ChangeTracker<{
    workerId: number
    blob: Blob
    type: 'DayStartConsent' | 'DayEndConsent'
}>

